module.exports = __webpack_public_path__ + "img/logo_sspp_white_narrow.f98d69b0.png";